<footer class="footer text-faded text-center py-1">
    <div class="container"><p class="m-0 small">Copyright &copy; DWWM7 & CDA7 2021</p></div>
</footer>
